import * as React from "react";
import { useState, useCallback } from "react";
import { Formik } from "formik";
import { Col, DataWell } from "common/components/layout-styles";
import { INIT_EVENT_PROCEDURE, validations } from "./utils";
import NewButtons from "./NewButtons";
import FormButtons from "./FormButtons";
import FormBase from "./FormBase";
import useFormActions from "./useFormActions";
import EventProcedureLibraryForm from "../EventProcedureLibraryForm";
function Form({
  eventProcedure = INIT_EVENT_PROCEDURE,
  onSave = void 0,
  onDelete = void 0,
  onCancel = void 0
}) {
  const { handleSubmit, saving } = useFormActions();
  const [show, setShow] = useState(eventProcedure.id ? "new" : void 0);
  const onSubmit = (inValues) => {
    handleSubmit({ inValues, eventProcedureId: eventProcedure == null ? void 0 : eventProcedure.id, cb: onSave });
  };
  const handleCancel = useCallback(() => {
    setShow(void 0);
    onCancel == null ? void 0 : onCancel();
  }, [onCancel]);
  if (show === "new") {
    return /* @__PURE__ */ React.createElement(Formik, { initialValues: eventProcedure, validate: validations, onSubmit }, /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(FormBase, null), /* @__PURE__ */ React.createElement(
      FormButtons,
      {
        isEdit: !!eventProcedure.id,
        onRemove: () => onDelete == null ? void 0 : onDelete(eventProcedure.id),
        saving,
        onCancel
      }
    ))));
  }
  if (show === "library") {
    return /* @__PURE__ */ React.createElement(EventProcedureLibraryForm, { onClose: () => setShow(void 0), onAdd: (id) => onSave(id) });
  }
  return /* @__PURE__ */ React.createElement(
    NewButtons,
    {
      onCancel: handleCancel,
      onFromLibrary: () => setShow("library"),
      onNewEventProcedure: () => setShow("new")
    }
  );
}
export default Form;
